module.exports = __webpack_public_path__ + "img/Component11–1.147c1cd1.png";